import { render, staticRenderFns } from "./LatestOrdersCardComponent.vue?vue&type=template&id=9e275864&scoped=true&"
import script from "./LatestOrdersCardComponent.vue?vue&type=script&lang=js&"
export * from "./LatestOrdersCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./LatestOrdersCardComponent.vue?vue&type=style&index=0&id=9e275864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e275864",
  null
  
)

export default component.exports